import React, { Component } from "react";
import { withStyles } from "material-ui/styles";
import Grid from "material-ui/Grid";
import { get } from "../../services/apiServices";
import { post } from "../../services/apiServices";
import { token } from "../../services/authServices";
import TextField from "material-ui/TextField";
import { InputLabel } from "material-ui/Input";
import { FormControl } from "material-ui/Form";
import { FormControlLabel } from "material-ui/Form";
import Dialog, { DialogTitle, DialogActions } from "material-ui/Dialog";
import Table, {
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import { MenuItem } from "material-ui/Menu";
import { CircularProgress } from "material-ui/Progress";

const styles = {
    closeIcon: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        color: '#a9a9a9',
        cursor: 'pointer'
    },
    editIcon: {
        padding: '10px',
        cursor: 'pointer'
    },
    button: {
        width: '120px',
        margin: '0 auto 40px'
    },
    titleWrap: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        color: '#3f51b5'
    },
    table: {
        minWidth: 700,
    },
    tableRow: {
        cursor: 'pointer'
    },
    listItem: {
        width: "480px",
        alignItems: "flex-start",
        borderBottom: "1px solid rgba(224, 224, 224, 1)"
    },
    listItemText: {
        flex: "1 1 50%"
    },
    listItemTtitle: {
        fontWeight: 600
    },
    progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    }
};
class Badges extends Component {
    classes = this.props.classes;
    state = {
        openConfirm: false,
        openModal: false,
        currentItem: {},
        badges: [],
        categories: [],
        groups: [],
        supported_mime: [
            'application/svg+xml',
            'image/svg+xml',
            'image/png',
            'image/jpeg',
            'image/jpg'
        ]
    }
    componentWillMount() {
        this.props.getBadges()
    }

    componentWillReceiveProps(props) {
        if (props.badges && props.badges.items) {
            let categories = {}
            let groups = {}
            props.badges.categories.forEach(item => {
                categories[item.id] = item
            })
            props.badges.groups.forEach(item => {
                groups[item.id] = item
            })
            this.setState({
                badges: props.badges.items,
                categories,
                groups,
            })
        }
    }

    handleOpenModalConfirm = (id, e) => {
        e.stopPropagation()

        this.setState({
            'openConfirm': true,
            'deleteId': id
        })
    }

    handleCloseModalConfirm = () => {
        this.setState({
            'openConfirm': false,
            'deleteId': null
        })
    }

    rendersList = () => {
        let { badges, categories, groups } = this.state
        let result = badges.map(item => {
            return (
                <TableRow
                    className={this.classes.tableRow}
                    key={item.id}>
                    <TableCell padding='none'>
                        {item.title}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.title_colour}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.description}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.type}
                    </TableCell>
                    <TableCell padding='none'>
                        <img src={item.icon} width="50px"/>
                    </TableCell>
                    <TableCell padding='none'>
                        <img src={item.icon_shaded} width="50px"/>
                    </TableCell>
                    <TableCell padding='none'>
                        {item.condition}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.order}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.category ? item.category.name : ''}
                    </TableCell>
                    <TableCell padding='none'>
                        {item.group ? item.group.icon : ''}
                    </TableCell>
                    <TableCell width="100px" padding='none'>
                        <Icon
                            className={this.classes.editIcon}
                            onClick={(e) =>
                                this.edit(item)}>
                            mode_edit
						</Icon>
                        <Icon
                            className={this.classes.editIcon}
                            onClick={(e) =>
                                this.handleOpenModalConfirm(item.id, e)}>
                            delete
						</Icon>
                    </TableCell>
                </TableRow>
            )
        })

        return result.map(item => item)
    }

    edit = (item = {}) => {
        this.setState({ currentItem: item })
        this.handleOpenModal()
    }

    delete = id => {
        post(`/admin/achievements/${id}/delete`, {}, token).then(res => {
            this.handleCloseModalConfirm()
            this.props.getBadges()
        }).catch(err => {
            this.setState({
                'openSnackbar': true,
                'message': `Badge id "${id}" doesn't exist`
            })
        })
    }

    handleOpenModal = () => {
        this.setState({ openModal: true })
    }

    handleCloseModal = () => {
        this.setState({ openModal: false })
    }

    handleInputChange = e => {
        let { currentItem } = this.state
        currentItem[e.target.name] = e.target.value;
        this.setState({ currentItem })
    }

    handleSelectCategoryChange = e => {
        let { currentItem, categories } = this.state
        let category = categories[e.target.value]
        currentItem.category = category
        this.setState({
            currentItem
        })
    }

    handleSelectGroupChange = e => {
        let { currentItem, groups } = this.state
        let group = groups[e.target.value]
        currentItem.group = group
        this.setState({
            currentItem
        })
    }

    handleSelectTypeChange = e => {
        let { currentItem } = this.state
        currentItem.type = e.target.value
        this.setState({
            currentItem
        })
    }

    handleImageChange = e => {
        let { currentItem } = this.state
        let file = e.target.files.length > 0 ? e.target.files[0] : {}
        if (this.state.supported_mime.includes(file.type)) {
            currentItem.image = file
            this.setState({
                currentItem
            })
        } else {
            e.target.value = null
            this.setState({
                'openSnackbar': true,
                'message': `This file type not supported`
            })
        }

    }

    handleImageShadedChange = e => {
        let { currentItem } = this.state
        let file = e.target.files.length > 0 ? e.target.files[0] : {}
        if (this.state.supported_mime.includes(file.type)) {
            currentItem.image_shaded = file
            this.setState({
                currentItem
            })
        } else {
            e.target.value = null
            this.setState({
                'openSnackbar': true,
                'message': `This file type not supported`
            })
        }

    }

    onSubmit = () => {
        const { currentItem } = this.state
        let id = currentItem.id ? `/${currentItem.id}` : ''
        let formData = new FormData()

        formData.append('title', currentItem.title || '')
        formData.append('title_colour', currentItem.title_colour || '#ffffff')
        formData.append('description', currentItem.description || '')
        formData.append('type', currentItem.type || '')
        formData.append('condition', currentItem.condition || '')
        formData.append('order', currentItem.order || 0)
        formData.append('category_id', currentItem.category ? currentItem.category.id : '')
        formData.append('group_id', currentItem.group ? currentItem.group.id : '')
        formData.append('image', currentItem.image || '')
        formData.append('image_shaded', currentItem.image_shaded || '')
        
        post(`/admin/achievements${id}`, formData, token, null, 'application/x-www-form-urlencoded').then(res => {
            this.handleCloseModal();
            this.props.getBadges()
        })
    }

    render() {
        const { badges } = this.props
        const { openModal, currentItem } = this.state
        let isFetching = badges ? badges.isFetching : true;

        return isFetching ? (
            <div className={this.classes.progressWrapper}>
                <CircularProgress className={this.classes.progress} size={50} />
            </div>
        ) : (
                <div>
                    <Dialog
                        open={this.state.openConfirm}
                        onClose={this.handleCloseModalConfirm}>
                        <DialogTitle>
                            <Icon
                                className={this.classes.closeIcon}
                                onClick={this.handleCloseModalConfirm}>
                                close
							</Icon>
                            <br />
                            Are you sure you want delete this badge?
						</DialogTitle>
                        <DialogActions className={this.classes.justifyCenter}>
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={() => this.delete(this.state.deleteId)}>
                                Yes
							</Button>
                            <Button
                                variant="raised"
                                color="primary"
                                onClick={this.handleCloseModalConfirm}>
                                No
							</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        className="modal-wrap align-center"
                        open={openModal}
                        onClose={this.handleCloseModal}
                        aria-labelledby="simple-dialog-title">
                        <Icon
                            className={this.classes.closeIcon}
                            onClick={this.handleCloseModal}>
                            close
					</Icon>
                        {
                            currentItem.id ?
                                (
                                    <DialogTitle id="simple-dialog-title">
                                        Edit badge
							</DialogTitle>
                                ) :
                                (
                                    <DialogTitle id="simple-dialog-title">
                                        Add badge
							</DialogTitle>
                                )
                        }
                        <div className="input-wrap">
                            <TextField
                                id="title"
                                label="Title"
                                name="title"
                                value={currentItem.title}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        <div className="input-wrap">
                            <TextField
                                id="title_colour"
                                label="Title Colour"
                                name="title_colour"
                                value={currentItem.title_colour !== undefined ? currentItem.title_colour : '#ffffff'}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        <div className="input-wrap">
                            <TextField
                                id="description"
                                label="Description"
                                name="description"
                                value={currentItem.description}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        <div className="input-wrap">
                            <FormControl className={this.classes.select}>
                                <InputLabel htmlFor="type-select">
                                    Type
                                </InputLabel>
                                <Select
                                    value={currentItem.type !== undefined ? currentItem.type : ""}
                                    onChange={this.handleSelectTypeChange}
                                    inputProps={{
                                        id: "type-select",
                                    }}
                                    autoWidth
                                >
                                    <MenuItem value="Answers">
                                        Answers
                                    </MenuItem>
                                    <MenuItem value="BotProgress">
                                        BotProgress
                                    </MenuItem>
                                    <MenuItem value="Challenge">
                                        Challenge
                                    </MenuItem>
                                    <MenuItem value="Coins">
                                        Coins
                                    </MenuItem>
                                    <MenuItem value="Levels">
                                        Levels
                                    </MenuItem>
                                    <MenuItem value="Stage">
                                        Stage
                                    </MenuItem>
                                    <MenuItem value="Stars">
                                        Stars
                                    </MenuItem>
                                    <MenuItem value="Streak">
                                        Streak
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className="input-wrap">
                            <TextField
                                id="condition"
                                label="Condition"
                                name="condition"
                                value={currentItem.condition}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        <div className="input-wrap">
                            <TextField
                                id="order"
                                label="Order"
                                name="order"
                                value={currentItem.order}
                                onInput={this.handleInputChange}
                                margin="normal"
                                fullWidth
                            />
                        </div>
                        {badges.categories && badges.categories.length > 0 && <div className="input-wrap">
                            <FormControl className={this.classes.select}>
                                <InputLabel htmlFor="category-select">
                                    Category
                                </InputLabel>
                                <Select
                                    value={currentItem.category ? currentItem.category.id : 0}
                                    onChange={this.handleSelectCategoryChange}
                                    inputProps={{
                                        id: "category-select",
                                    }}
                                    autoWidth
                                >
                                    {badges.categories.map((item, index) => {
                                        return (<MenuItem key={index} value={item.id}>
                                            {item.name}
                                        </MenuItem>)
                                    })}
                                </Select>
                            </FormControl>
                        </div>}
                        {badges.groups && badges.groups.length > 0 && <div className="input-wrap">
                            <FormControl className={this.classes.select}>
                                <InputLabel htmlFor="group-select">
                                    Group
                                </InputLabel>
                                <Select
                                    value={currentItem.group ? currentItem.group.id : 0}
                                    onChange={this.handleSelectGroupChange}
                                    inputProps={{
                                        id: "group-select",
                                    }}
                                    autoWidth
                                >
                                    {badges.groups.map((item, index) => {
                                        return (<MenuItem key={index} value={item.id}>
                                            {item.icon}
                                        </MenuItem>)
                                    })}
                                </Select>
                            </FormControl>
                        </div>}
                        <div className="input-wrap">
                            <div>
                                <label>Icon</label>
                            </div>
                            <input
                                id="image"
                                name="image"
                                onChange={this.handleImageChange}
                                type="file"
                            />
                        </div>
                        <div className="input-wrap">
                            <div>
                                <label>Icon Shaded</label>
                            </div>
                            <input
                                id="image_shaded"
                                name="image_shaded"
                                onChange={this.handleImageShadedChange}
                                type="file"
                            />
                        </div>
                        <Button
                            variant="raised"
                            color="primary"
                            className={this.classes.button}
                            onClick={this.onSubmit}
                        //disabled={disable}
                        >
                            {currentItem.id ? "Edit" : "Add"}
                        </Button>
                    </Dialog>
                    <div className={this.classes.titleWrap}>
                        <h2 className={this.props.classes.title}>Badges</h2>
                        <Button
                            variant="raised"
                            color="primary"
                            onClick={() => this.edit()}>
                            Add new badge
						</Button>
                    </div>
                    {badges && badges.items.length &&
                        <Table className={this.classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell padding='none'>
                                        TITLE
									</TableCell>
                                    <TableCell padding='none'>
                                        TITLE COLOUR
									</TableCell>
                                    <TableCell padding='none'>
                                        DESCRIPTION
									</TableCell>
                                    <TableCell padding='none'>
                                        TYPE
									</TableCell>
                                    <TableCell padding='none'>
                                        ICON
									</TableCell>
                                    <TableCell padding='none'>
                                        ICON SHADED
									</TableCell>
                                    <TableCell padding='none'>
                                        CONDITION
									</TableCell>
                                    <TableCell padding='none'>
                                        ORDER
									</TableCell>
                                    <TableCell padding='none'>
                                        CATEGORY
									</TableCell>
                                    <TableCell padding='none'>
                                        GROUP
									</TableCell>
                                    <TableCell padding='none'>
                                        ACTIONS
									</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.rendersList()}
                            </TableBody>
                        </Table>}
                </div>
            )
    }
}

export default withStyles(styles)(Badges);


// WEBPACK FOOTER //
// ./src/components/content/Badges.js